import React, { createContext, ReactElement, useContext } from 'react';

import { CreateLink } from 'use-case/link/create/createLinkUseCase';
import { DeleteLink } from 'use-case/link/delete/deleteLinkUseCase';
import { ReadCSVLocationLinks } from 'use-case/link/read/readCSVLocationLinksUseCase';
import { ReadLinks } from 'use-case/link/read/readLinksUseCase';
import { EnableLink } from 'use-case/link/update/updateLinkUseCase';

export type LinksDispatch = {
    createLink: CreateLink;
    readLinks: ReadLinks;
    enableLink: EnableLink;
    deleteLink: DeleteLink;
    readCSVLocationLinks: ReadCSVLocationLinks;
};

export const LinksContext = createContext({} as LinksDispatch);
export const useLinks = (): LinksDispatch => useContext(LinksContext);

type LinkProviderType = {
    createLink: CreateLink;
    readLinks: ReadLinks;
    enableLink: EnableLink;
    deleteLink: DeleteLink;
    readCSVLocationLinks: ReadCSVLocationLinks;
    children: ReactElement | ReactElement[];
};

export const LinksProvider = (props: LinkProviderType): ReactElement => {
    const { children, createLink, readLinks, enableLink, deleteLink, readCSVLocationLinks } = props;

    return (
        <LinksContext.Provider
            value={{
                createLink,
                readLinks,
                enableLink,
                deleteLink,
                readCSVLocationLinks,
            }}
        >
            {children}
        </LinksContext.Provider>
    );
};
